// src/com/sms_sent/SmsSent.js
import React, { useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { AppNumber, AppObject } from '../../model/AppConst';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { smsSentListRepo } from '../../model/CvoModel';
import SmsSentCustList from './SmsSentCustList';
import ValueUtil from '../../model/ValueUtil';
import { GET_SMS_SENT_LIST, GET_SMS_SENT_LIST_OVER_CUST } from './SmsSentGql';
import ResponseAlert from '../message/ResponseAlert';
import SmsSentListOverCust from './SmsSentListOverCust';

const MinCustListBoxWidth = 450;
const dcPad = AppNumber.dataContainerPadding;
// cust + term box
const SmsSentContainer = styled(Box)({
    position:"absolute", top:dcPad, bottom:dcPad, left:dcPad, right:dcPad,
    display: 'flex'
});
const CustListBox = styled(Box)({
    display:'flex', // flexDirection:'column',
    minWidth: MinCustListBoxWidth, marginRight: 5,
});
// Container for term-list
const DetailBox = styled(Box)({
    flexGrow:1,
    display: 'flex', flexDirection: 'column',
});

function getLastMonth01() {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    date.setDate(1);
    return date;
}

export default function SmsSent() {
    const [date, setDate] = useState(ValueUtil.getYmdOfDate(getLastMonth01())); // 1개월 전
    const [custSelected, setCustSelected] = useState(null);
    const smsSentListGroupByCust = useReactiveVar(smsSentListRepo);
    const [smsSentListOverCust, setSmsSentListOverCust] = useState([]);
    const [responseAlert, setResponseAlert] = useState(null);

    const [getSmsSentList, responseListCust] = useLazyQuery(GET_SMS_SENT_LIST, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => onCompleteGetSmsSentList(data, option),
        onError:  (error) => {
            setResponseAlert({open:true, error: error, title: "정산정보 업체별 통계 조회 오류"});
        }
	});

    const [getSmsSentListOverCust, responseListOverCust] = useLazyQuery(GET_SMS_SENT_LIST_OVER_CUST, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => onCompleteGetSmsSentListOverCust(data, option),
        onError:  (error) => {
            setResponseAlert({open:true, error: error, title: "정산정보 업체별 상세내역 조회 오류"});
        }
    });

    const onCompleteGetSmsSentList = (data, option) => {
        if(data.smsSentList) {
            smsSentListRepo(data.smsSentList);

            setSmsSentListOverCust([]);
            setCustSelected(null);
        }
    };

    const onCompleteGetSmsSentListOverCust = (data, option) => {
        if(data.smsSentListOverCust) {
            setSmsSentListOverCust(data.smsSentListOverCust);
        }
    };

    const onSelectCust = (row) => {
        setCustSelected(row);
        // call query to get smsSentListOverCust
        getSmsSentListOverCust({variables:{custId: row.custId, dateFrom: date}});
    };

    const onRequestGetList = () => {
        getSmsSentList({variables:{dateFrom: date}});
    };

    const onChangeDate = (date) => {
        setDate(date);
    };

    return(
        <SmsSentContainer>
            <CustListBox>
                <SmsSentCustList
                    records={smsSentListGroupByCust}
                    onClickItem={onSelectCust}
                    dateSelected={date}
                    onChangeDate={onChangeDate}
                    onRequestGetList={onRequestGetList}
                    responseList={responseListCust}
                />
            </CustListBox>
            <DetailBox>
                <SmsSentListOverCust
                    date={date}
                    records={smsSentListOverCust}
                    itemCust={custSelected}
                />
            </DetailBox>
            <ResponseAlert open={responseAlert ? responseAlert.open : false}
                alertData={responseAlert}
                onClose={() => {setResponseAlert(null)}}/>
        </SmsSentContainer>
    );
}
